import {
    SITE_URL,
    SITE_TITLE,
    SITE_DESCRIPTION,
} from '~/constants';

export const useDefaultHead = () => {
    const route = useRoute();
    useHead({
        link: [
            {
                rel: 'canonical',
                href: `${SITE_URL}${route.path}`,
            },
        ],
    });

    useSeoMeta({
        title: SITE_TITLE,
        description: SITE_DESCRIPTION,
        robots: 'index, follow',
    });
};
